
import React from "react";
import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BreadcrumbsBar = ({ crumbs }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {crumbs.map((crumb, index) =>
        crumb.current ? (
          <Typography
            key={index}
            color="text.primary"
            sx={{
              display: "inline-block",
              py: 1
            }}
          >
            {crumb.label}
          </Typography>
        ) : (
          <MuiLink
            key={index}
            underline="hover"
            color="inherit"
            onClick={(e) => {
              e.preventDefault();
              navigate(crumb.path);
            }}
            sx={{
              cursor: "pointer",
              padding: "8px 12px",
              display: "inline-block",
              py: 1,
              px: 1.5,
              borderRadius: "4px",
            }}
          >
            {crumb.label}
          </MuiLink>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbsBar;
